const initialState = {
  shopName: "",
  shopRoute: "",
  ownerEmail: "",
  ownerUser: null,
  ownerStatus: "idle",
  shopType: "Talent",
  payoutSameAsOwner: true,
  payoutEmail: "",
  payoutUser: null,
  payoutStatus: "idle",
  shipping: {
    firstName: "",
    lastName: "",
    country: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
  },
  vertical: null,
  subvertical: null,
  submitting: false,
  error: null,
  routeError: null,
};

const ACTION = {
  SET_FIELD: "SET_FIELD",
  SET_OWNER: "SET_OWNER",
  SET_PAYOUT_USER: "SET_PAYOUT_USER",
  SET_SHIPPING_FIELD: "SET_SHIPPING_FIELD",
  SET_ROUTE_ERROR: "SET_ROUTE_ERROR",
  SUBMIT_START: "SUBMIT_START",
  SUBMIT_SUCCESS: "SUBMIT_SUCCESS",
  SUBMIT_ERROR: "SUBMIT_ERROR",
  RESET: "RESET",
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION.SET_FIELD:
      return {
        ...state,
        [action.field]: action.value,
        error: null,
        ...(action.field === "shopRoute" ? { routeError: null } : {}),
      };

    case ACTION.SET_OWNER:
      return {
        ...state,
        ownerUser: action.user,
        ownerStatus: action.status,
        error: null,
      };

    case ACTION.SET_PAYOUT_USER:
      return {
        ...state,
        payoutUser: action.user,
        payoutStatus: action.status,
        error: null,
      };

    case ACTION.SET_SHIPPING_FIELD:
      return {
        ...state,
        shipping: { ...state.shipping, [action.field]: action.value },
        error: null,
      };

    case ACTION.SET_ROUTE_ERROR:
      return { ...state, routeError: action.error };

    case ACTION.SUBMIT_START:
      return { ...state, submitting: true, error: null, routeError: null };

    case ACTION.SUBMIT_SUCCESS:
      return { ...initialState };

    case ACTION.SUBMIT_ERROR:
      return { ...state, submitting: false, error: action.error };

    case ACTION.RESET:
      return { ...initialState };

    default:
      return state;
  }
};

export { ACTION, initialState, reducer };
